interface GoalCardProps {
    goalName: string;
    goalStatus: string;
    endDate: string;
    employeeTaskCount: number;
    employeeActualHours: number;
}

const GoalCard = ({ goalName, goalStatus, endDate, employeeTaskCount, employeeActualHours }: GoalCardProps) => {
    const getStatusColor = (status: string) => {
        const statusLower = status.toLowerCase();
        if (statusLower.includes('completed') || statusLower.includes('on track')) {
            return 'bg-success-active text-white';
        } else if (statusLower.includes('at risk') || statusLower.includes('in progress')) {
            return 'bg-warning-active text-white';
        } else if (statusLower.includes('off track') || statusLower.includes('delayed')) {
            return 'bg-danger-active text-white';
        }
        return 'bg-surface-bg-secondary text-text-text-secondary';
    };

    const formatDate = (dateString: string) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    };

    return (
        <div className="bg-surface-bg-primary border border-surface-border rounded-lg p-4 hover:shadow-sm transition-shadow user-project-card">
            <div className="flex items-start justify-between gap-4">
                <div className="flex items-start gap-3 flex-1">
                   <div className="w-10 h-10  border-2 border-surface-border flex items-center justify-center mt-1 inner-user-project-card">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                            <polyline points="22 4 12 14.01 9 11.01" />
                        </svg>
                    </div>
                    <div className="flex-1">
                        {/* Line 1: Goal Name and Goal Status */}
                        <div className="flex items-center justify-between gap-2 mb-2">
                            <h4 className="text-sm font-semibold flex-1">{goalName}</h4>
                            <span className={`text-xs px-2 py-1 rounded whitespace-nowrap ${getStatusColor(goalStatus)}`}>
                                {goalStatus}
                            </span>
                        </div>
                        {/* Line 2: End Date, Task Count, Actual Hours */}
                        <div className="flex items-center gap-3 text-xs text-text-text-secondary flex-wrap">
                            <span className="flex items-center gap-1">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                    <line x1="16" y1="2" x2="16" y2="6" />
                                    <line x1="8" y1="2" x2="8" y2="6" />
                                    <line x1="3" y1="10" x2="21" y2="10" />
                                </svg>
                                {formatDate(endDate)}
                            </span>
                            <span className="flex items-center gap-1">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                </svg>
                                {employeeTaskCount} {employeeTaskCount === 1 ? 'Task' : 'Tasks'}
                            </span>
                            <span className="flex items-center gap-1">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10" />
                                    <polyline points="12 6 12 12 16 14" />
                                </svg>
                                {employeeActualHours.toFixed(1)}h
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GoalCard;
